import { render, staticRenderFns } from "./phoneBooks.vue?vue&type=template&id=61861e69&scoped=true&"
import script from "./phoneBooks.vue?vue&type=script&lang=js&"
export * from "./phoneBooks.vue?vue&type=script&lang=js&"
import style0 from "./phoneBooks.vue?vue&type=style&index=0&id=61861e69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61861e69",
  null
  
)

export default component.exports